import React from 'react';
import DefectDot from '../../Components/DefectDot';
import RegularDot from '../../Components/RegularDot';

export const renderCustomDot = (props, item, config, className = '') => {
  const { cx, cy, payload, stroke, fill } = props;
  
  if (config?.customDotRenderer) {
    return config.customDotRenderer(props, item);
  }
  
  const hasDefects = payload.defects && payload.defects.length > 0;
  
  if (hasDefects) {
    return <DefectDot 
             cx={cx} 
             cy={cy} 
             className={className}
             payload={payload}
           />;
  } else {
    return <RegularDot 
             cx={cx} 
             cy={cy} 
             stroke={stroke}
             fill={item.defaultColor}
             strokeWidth={2}
             r={6}
             className={className} 
           />;
  }
};

export const renderActiveDot = (props, item, handleClick, className = '') => {
  const { cx, cy, payload, stroke, fill } = props;
  const hasDefects = payload.defects && payload.defects.length > 0;
  
  return (
    <g 
      onClick={(e) => handleClick && handleClick(e, payload, item)}
      style={{ cursor: handleClick ? "pointer" : "default" }}
      className={className}
    >
      {hasDefects ? (
        <DefectDot 
          cx={cx} 
          cy={cy} 
          className={className}
          payload={payload}
        />
      ) : (
        <circle 
          cx={cx} 
          cy={cy} 
          r={8} 
          stroke={stroke || '#8884d8'} 
          strokeWidth={2}
          fill={fill || '#fff'}
        />
      )}
    </g>
  );
}; 